


import { createSlice } from "@reduxjs/toolkit";

const fastrackJourneySlice = createSlice({
    name: 'fastrackJourneySlice',
    initialState: {
        currentStep: '1'
    },
    reducers: {
        setFastrackJourney: (state, action): any => {
            return action.payload
        },
        updateFastrackJourney: (state, action): any => {
            return {
                ...state,
                ...action.payload
            }
        },
        deleteCompletionStatusAndUpdate: (state, action): any => {
            const newState: any = {...state}
            delete newState.processCompleted
            return {
                ...newState,
                ...action.payload
            }
        },
        resetFastrackJourney: (state): any => {
            return {
                currentStep: '1'
            }
        },
    },
});
export const { setFastrackJourney, updateFastrackJourney, resetFastrackJourney, deleteCompletionStatusAndUpdate } = fastrackJourneySlice.actions;
export default fastrackJourneySlice.reducer;